/**
 *     Import
 *     - Libraries
 */
import * as React from 'react'

/**
 *     Import
 *     - Componernt
 */
import DatePicker from '../../../common/DatePicker/DatePicker'

/**
 * Class for the content inside the MTA Edit PopUp
 *
 * @export
 * @class MtaPopUp
 * @extends {React.Component<any, any>}
 */
export default class MtaPopUp extends React.Component<any, any> {

    /**
     * Creates an instance of MtaPopUp.
     * @param {*} props
     * @memberof MtaPopUp
     */
    constructor(props: any) {
        super(props)
        this.state = {
            selectedButton: null,
        }
    }

    /**
     * On focus set Label element with class 'active'
     *
     * @memberof MtaPopUp
     * @param {any} event
     */
    focusChange = (event: any) => {
        if (event.target.classList.contains('calendar__input')) {
            event.target.parentNode.parentNode.previousSibling.classList = 'active'
        } else {
            event.target.previousSibling.classList = 'active'
        }
    }

    /**
     * Will update the state with the new button selected
     *
     * @memberof MtaPopUp
     * @param {number} selectedButton the button selected
     */
    changeSelectedButton = (selectedButton: number) => {
        this.setState({ selectedButton })
    }

    render() {
        return (
            <div>
                <div className="calendar w55">
                    <label>Policy inception date</label>
                    <DatePicker
                        placeholder="Effective date"
                        onChange={() => { alert('Hi there!') }}
                        onFocus={this.focusChange}
                    />
                </div>
                <div className="calendar w45">
                    <label>Policy inception date</label>
                    <DatePicker
                        placeholder="Set MTA expiry date (opcional)"
                        onChange={() => { alert('Hi there!') }}
                        onFocus={this.focusChange}
                    />
                </div>

                <div className="mtatype-box">
                    <label>Choose MTA type</label>
                    <div className="mtatype-box__content">
                        <div className="switchies">
                            <div
                                className={`switch
                                        ${(this.state.selectedButton === 0) ?
                                        `selected` :
                                        ``}`}
                                onClick={() => { this.changeSelectedButton(0) }}
                            >
                                Sums insured
                            </div>
                            <div
                                className={`switch
                                ${(this.state.selectedButton === 1) ?
                                        `selected` :
                                        ``}`}
                                onClick={() => { this.changeSelectedButton(1) }}
                            >
                                Location
                            </div>
                            <div
                                className={`switch
                                ${(this.state.selectedButton === 2) ?
                                        `selected` :
                                        ``}`}
                                onClick={() => { this.changeSelectedButton(2) }}
                            >
                                Other
                            </div>
                        </div>
                    </div>
                </div>

            </div>

        )
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/pages/Clients/components/MtaPopUp.tsx